import React, { useEffect } from 'react';
import { fetchReports, clearReportingsData } from 'state/actions/reporting';
import { useFormatMessage, useFormatDate } from 'hooks';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import useFilterSearch from 'hooks/useFilterSearch';
import FilterSearch from 'components/Common/FilterSearch';
import Table from 'components/Table';
import sortByDate from 'utils/sortByDate';

const Reporting = () => {
  const { ReportingList, loading } = useSelector(
    (state) => ({
      success: state.reportings.success,
      ReportingList: state.reportings.data,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchReports());
    return () => dispatch(clearReportingsData());
  }, [dispatch]);

  const columns = [
    {
      Header: 'Activation ID',
      accessor: 'activationId',
    },
    {
      Header: 'Produit ID',
      accessor: 'idProduit',
    },
    {
      Header: 'Message',
      accessor: 'message',
    },

    {
      Header: 'Date de création',
      accessor: 'createdAt',
      sortType: sortByDate,
      Cell: ({ row }) => (
        <small className="has-text-grey is-abbr-like">
          {useFormatDate(row.original.createdAt, {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          })}
        </small>
      ),
    },
  ];

  const { result, searchProps, selectProps } = useFilterSearch(ReportingList);

  return (
    <>
      <section className="hero is-hero-bar">
        <div className="hero-body">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h1 className="text-brand-darkBlue text-3xl font-semibold">
                  Reporting
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="page-padding">
        {/* filters  */}
        <div className="flex items-center justify-between px-2">
          <FilterSearch
            loading={loading}
            searchProps={searchProps}
            selectProps={selectProps}
          />
        </div>
        {/* table  */}
        <div className="p-2">
          <Table loading={loading} columns={columns} data={result} />
        </div>
      </div>
    </>
  );
};
export default Reporting;
